import React, { useEffect, useState, useImperativeHandle } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import InformationTooltip from "components/CustomTooltips/InformationTooltip.js";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";
import Face from "@material-ui/icons/Face";
import MexicoFlagIcon from "components/CustomIcons/MexicoFlag";
import UsaFlagIcon from "components/CustomIcons/UsaFlag";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomOutlinedInput.js";
import CustomDatePicker from "components/CustomDatePicker/CustomDatePicker.js";
import CustomSelect from "components/CustomSelect/CustomSelect.js";
import CustomDialog from "components/CustomDialog/CustomDialog.js";
import PriceCard from "components/CardComponents/PriceCard";
import CustomToogle from "components/CustomToogle/CustomToogle.js";
import Button from "components/CustomButtons/CustomButton";
import AccidentIcon from "components/CustomIcons/Accident";
import LegalIcon from "components/CustomIcons/Legal";
import TheftIcon from "components/CustomIcons/Theft";
import FormControl from "@material-ui/core/FormControl";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CustomAlerts from "components/Alerts/CustomAlerts";
import StepperComponent from "components/Stepper/StepperComponent";

import styles from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.js";
import stylePrincipal from "assets/jss/material-dashboard-pro-react/components/principalStyle.js";
import DriveEtaIcon from "@material-ui/icons/DriveEta";

import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { getRatesRedesign } from "views/Services/OrdersService";
import {
  formatNumber,
  fixDaysMonths,
  currentDateEffective,
  addDays,
  getDaysFromDates,
  formatDateToEffectiveAndExpiration,
  validValueCoverage,
  getUTCDate,
  isAgent,
} from "components/Utils/utils.js";
import { useTranslation } from "react-i18next";
import AccordionCoverages from "components/AccordionCoverages/AccordionCoverages";
import AccordionCoveragesAgent from "components/AccordionCoveragesAgent/AccordionCoveragesAgent";
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));
const useStylesPrincipal = makeStyles(stylePrincipal);
const useStyles = makeStyles(styles);
let current_date = new Date();

const Step1 = React.forwardRef((props, ref) => {
  const { t } = useTranslation();
  useImperativeHandle(ref, () => ({
    sendStepData,
    checkValidateDate,
    saveStepComplete,
  }));
  const sendStepData = (type) => {
    submitAction(coverages, resultRates, type);
  };
  const saveStepComplete = (save) => {
    handleSubmitStep(save);
  };
  const checkValidateDate = (coverages, vehicleData) => {
    validateDateAndTime(
      coverages.startDate,
      coverages.timeset,
      coverages.meridian,
      coverages.timezone
    );
    validateComplete(vehicleData);
  };
  let USDollar = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });
  const {
    isSmall,
    submitAction,
    setPaymentModal,
    previewAction,
    changeStep,
    isLogged,
    currentStartDate,
  } = props;
  const handlePreviewAction = async (event) => {
    previewAction();
  };
  const routeParams = useParams();
  const { userId, token, type } = routeParams;
  const dispatch = useDispatch();
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false);
  const classesPrincipal = useStylesPrincipal();
  const [toastMessage, setToastMessage] = useState(false);
  const [validDate, setValidDate] = useState(0);
  const [refreshQuote, setRefreshQuote] = useState(false);
  const [oneClicValidate, setOneClicValidate] = useState(false);
  const [oneClickLogin, setOneClickLogin] = useState(false);
  const [messageToast, setMessageToast] = useState("");
  const [seePassword, setSeePassword] = useState(false);
  const [loginCredentials, setLoginCredentials] = useState({
    login: "",
    password: "",
  });
  const [sended, setSended] = useState(false);
  const classes = useStyles();
  const [vehicleData, setVehicleData] = useState({ vehtype: 1, agent: 441 });
  const [valores, setValores] = useState([]);
  const [gettingQuote, setGettingQuote] = useState(false);
  const [vehTypeState, setVehTypeState] = useState("error");
  const [fieldEndorsement, setFieldEndorsement] = useState("");
  const trailerTypes = [
    { id: 1, name: "Trailer" },
    { id: 2, name: "Boat" },
    { id: 3, name: "Other" },
    { id: 4, name: "ATV/UTV" },
  ];
  const daysOptions = [
    { value: 1, label: t("daysOptions.1day") },
    { value: 2, label: t("daysOptions.2days") },
    { value: 3, label: t("daysOptions.3days") },
    { value: 4, label: t("daysOptions.4days") },
    { value: 5, label: t("daysOptions.5days") },
    { value: 6, label: t("daysOptions.6days") },
    { value: 7, label: t("daysOptions.7days") },
    { value: 8, label: t("daysOptions.8days") },
    { value: 9, label: t("daysOptions.9days") },
    { value: 10, label: t("daysOptions.10days") },
    { value: 11, label: t("daysOptions.11days") },
    { value: 12, label: t("daysOptions.12days") },
    { value: 13, label: t("daysOptions.13days") },
    { value: 14, label: t("daysOptions.14days") },
    { value: 15, label: t("daysOptions.15days") },
    { value: 16, label: t("daysOptions.16days") },
    { value: 17, label: t("daysOptions.17days") },
    { value: 18, label: t("daysOptions.18days") },
    { value: 19, label: t("daysOptions.19days") },
    { value: 20, label: t("daysOptions.20days") },
    { value: 21, label: t("daysOptions.21days") },
    { value: 22, label: t("daysOptions.22days") },
    { value: 23, label: t("daysOptions.23days") },
    { value: 24, label: t("daysOptions.24days") },
    { value: 25, label: t("daysOptions.25days") },
    { value: 26, label: t("daysOptions.26days") },
    { value: 27, label: t("daysOptions.27days") },
    { value: 28, label: t("daysOptions.28days") },
    { value: 29, label: t("daysOptions.29days") },
    { value: 30, label: t("daysOptions.30days") },
    { value: 90, label: t("daysOptions.90days") },
    { value: 182, label: t("daysOptions.6months") },
    { value: 365, label: t("daysOptions.1year") },
  ];
  const timeZoneList = {
    1: 12,
    2: 8,
    3: 17,
    4: 33,
    5: 12,
    6: 33,
  };
  const [coverages, setCoverages] = useState({
    csllimit: "500000",
    excessliab: "150000",
    country: 0,
    policy_type: 1,
    medicallimit: "5000",
    damageded: 2,
    theftded: 5,
    vehtype: 1,
    year_vehicle: 2025,
    specialdiscount: 1,
    effectivedate: "10-23-2024",
    bordercross: 2,
    gapcoverage: "no",
    premierepackage: true,
    fixeddeductible: true,
    policycaravan: false,
    roadside: true,
    physical_damage: true,
    theft: true,
    legalaid: true,
    hdiautoguard: false,
    accessories_and_safety: false,
    ter_ext: false,
    days: 3,
    //meridian: "am",
  });
  const [resultRates, setResultRates] = useState({});

  useEffect(() => {
    if (props.data) {
      setData(props.data);
      setValuesForTypeVehicle(1, {});
      checkEndorsementType(props.data.coverages.endorsementtype);
    }
    if (props.vehicleData) {
      setVehicleData(props.vehicleData);
    }
    if (props.coverages) {
      setCoverages(props.coverages);
    }
    getQuoteRates(props.coverages, props.vehicleData);
  }, [props]);

  useEffect(() => {
    if (type === "oneClickLogin") {
      setOneClickLogin(true);
    }

    if (window.location.href.includes("checkTokenOneClick")) {
      setOneClicValidate(true);
      validateToken();
    }
  }, [dispatch]);

  const handleSubmit = async (event) => {
    getQuoteRates(coverages, vehicleData);
  };
  const handleSubmitStep = async (save) => {
    submitAction(coverages, resultRates, save);
  };

  const checkEndorsementType = (endorsementType) => {
    if (endorsementType == "Change Policy Start Date") {
      setFieldEndorsement("start_date");
    }
    if (endorsementType == "Change Policy Start Time") {
      setFieldEndorsement("start_time");
    }
    if (endorsementType == "Change Policy Time Zone") {
      setFieldEndorsement("time_zone");
    }
  };

  const setExpirationDate = (coveragesData) => {
    let expirationData = addDays(coveragesData.days, "effectivedate", {
      effectivedate: coveragesData.startDate,
    });
    let formatValueDate = formatDateToEffectiveAndExpiration(
      coveragesData.startDate,
      "quote"
    );
    coveragesData.effectivedate = formatValueDate.date;
    coveragesData.expirationdate = expirationData.expirationDate.date;
    validateDateAndTime(
      coveragesData.startDate,
      coveragesData.timeset,
      coveragesData.meridian
    );
    return coveragesData;
  };

  const handleFormChange = (e) => {
    const valor = e.target.value;
    let vehData = { ...vehicleData };
    let coveragesData = { ...coverages };
    vehData[e.target.name] = valor;
    const sendedData = {};
    if (e.target.name === "days") {
      vehData.selectedDays = valor;
      coveragesData.days = valor;
      coveragesData = setExpirationDate(coveragesData);
    }
    if (e.target.name === "startTime") {
      coveragesData.timeset = valor;
      coveragesData = setExpirationDate(coveragesData);
    }
    if (e.target.name === "startDate") {
      coveragesData.startDate = valor;
      coveragesData = setExpirationDate(coveragesData);
    }
    if (e.target.name === "borderCrossing") {
      let timeZoneList = {
        1: 12,
        2: 8,
        3: 17,
        4: 33,
        5: 12,
        6: 33,
      };
      coveragesData.timezone = timeZoneList[e.target.value];
      coveragesData = setExpirationDate(coveragesData);
    }
    if (e.target.name === "meridian") {
      coveragesData.meridian = valor;
      validateDateAndTime(
        coveragesData.startDate,
        coveragesData.timeset,
        coveragesData.meridian
      );
    }
    if (e.target.name === "days") {
      vehData.selectedDays = valor;
      coveragesData.days = valor;
    }
    if (e.target.name === "csrinitials") {
      coveragesData.csrinitials = valor;
    }
    if (e.target.name === "specialdiscount") {
      coveragesData.specialdiscount = valor;
    }
    if (e.target.name === "vehtype" || e.target.name === "year_vehicle") {
      if (e.target.name === "vehtype") {
        sendedData.vehtype = valor;
        setVehTypeState("success");
        sendedData.year_vehicle = vehicleData.year_vehicle;
        vehData.type_name = e.nativeEvent.target.textContent;
      } else {
        sendedData.vehtype = vehicleData.vehtype;
        sendedData.year_vehicle = valor;
        setYearState("success");
      }
      setValuesForTypeVehicle(valor, vehData);
    } else if (e.target.name === "make_vehicle" && showSelectMake) {
      sendedData.vehtype = vehicleData.vehtype;
      sendedData.make_vehicle = valor;
      setMakeState("success");
      getModelsData(sendedData);
    }
    if (e.target.name === "year_vehicle") {
      vehData.year_model = e.nativeEvent.target.textContent;
    }
    if (e.target.name === "make_vehicle") {
      vehData.make_name = ["1", "5"].includes(vehData.vehtype)
        ? e.nativeEvent.target.textContent
        : valor;
      vehData.makeId = valor;
    }
    if (e.target.name === "model_vehicle") {
      vehData.model_name = ["1", "5"].includes(vehData.vehtype)
        ? e.nativeEvent.target.textContent
        : valor;
      vehData.modelId = valor;
    }
    if (e.target.name === "value") {
      setValueState("success");
      vehData.value = valor;
    }
    if (e.target.name === "insurancepolnumber") {
      setFullCoverageState("success");
      vehData.insurancepolnumber = valor;
      if (valor == "No") {
        vehData.value = "0";
        formatValueField(0);
      } else {
        setValuesForTypeVehicle(1, vehData);
      }
    }
    if (vehData.initDate && vehData.endDate) {
      const initDate = new Date(vehData.initDate);
      const endDate = new Date(vehData.endDate);
      const diffTime = Math.abs(endDate - initDate);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      vehData.days = diffDays;
    }
    setVehicleData(vehData);
    validateComplete(vehData);
    setCoverages(coveragesData);
    changeStep(vehData, coveragesData);
  };

  const handleCoveragesChange = (e) => {
    const valor = e.target.value;
    let coveragesData = { ...coverages };
    if (e.target.name === "csllimit") {
      coveragesData.premierepackage = valor == "50000" ? false : true;
    }
    coveragesData[e.target.name] = valor;
    setCoverages(coveragesData);
  };
  const validateComplete = (data) => {
    const reqProperties = [
      "borderCrossing",
      "total_value_vehicle",
      "vehtype",
      "days",
      "agent",
    ];
    const allPropertiesValid = reqProperties.every((prop) => {
      return (
        data[prop] !== undefined && data[prop] !== null && data[prop] !== ""
      );
    });
    setIsCompleted(allPropertiesValid);
  };

  const setValuesForTypeVehicle = (type, vehData) => {
    let limitValue = 300000;
    type = parseInt(type);
    if ([1, 7, 13].includes(type)) {
      limitValue = 100000;
    }
    if (type == 5) {
      limitValue = 50000;
    }
    if (type == 11) {
      limitValue = 40000;
    }
    if (
      [10, 12].includes(type) ||
      current_date.getFullYear() - vehData.year_vehicle > 25
    ) {
      limitValue = 0;
    }
    formatValueField(limitValue);
  };

  const formatValueField = (limitValue) => {
    if (limitValue == 0) {
      let vehicleDataToEdit = { ...vehicleData };
      vehicleDataToEdit.value = 0;
      setVehicleData(vehicleDataToEdit);
    }
    const arreglov = [];
    for (let index = 0; index <= limitValue; index += 1000) {
      if (index === 0) {
        arreglov.push({ value: index, traduccion: "$0 - Liability only" });
      } else {
        index >= 3000 &&
          arreglov.push({ value: index, traduccion: USDollar.format(index) });
      }
    }
    setValores(arreglov);
  };

  const getQuoteRates = async (coveragesData, vehicle) => {
    let valueVehicle =
      typeof vehicle.total_value_vehicle != "undefined"
        ? parseInt(vehicle.total_value_vehicle || 0)
        : 0;
    let valueTrailer =
      typeof vehicle.total_value_trailer != "undefined"
        ? parseInt(
            vehicle.total_value_trailer > 0 ? vehicle.total_value_trailer : 0
          )
        : 0;
    let valueOther =
      typeof vehicle.total_value_other != "undefined"
        ? parseInt(
            vehicle.total_value_other > 0 ? vehicle.total_value_other : 0
          )
        : 0;
    let totalValue = valueVehicle + valueTrailer + valueOther;
    if (data) {
      let stringRates = {
        csl: coveragesData.csllimit,
        excessliab: coveragesData.excessliab,
        value: totalValue,
        days: vehicle.days,
        country: data.data_customer?.country_id,
        policy_type: coveragesData.policy_type,
        medicallimit: coveragesData.medicallimit,
        damageded: 2,
        theftded: 5,
        vehtype: vehicle.vehtype,
        year_vehicle: data.selectedVehicle?.vehicleYear,
        specialdiscount: coveragesData.specialdiscount,
        hasFullCoverage: vehicle.fullCoverage,
        agency_fee: coveragesData.agency_fee,
        effectivedate: coveragesData.effectivedate,
        vehicle_type_model: "",
        bordercross: vehicle.borderCrossing,
        agency: vehicle.agent,
        gapcoverage: coveragesData.gapcoverage == "no" ? false : true,
        premierepackage: coveragesData.premierepackage,
        fixeddeductible: coveragesData.fixeddeductible,
        policycaravan: false,
        roadside: coveragesData.roadside,
        physical_damage: coveragesData.physical_damage,
        theft: coveragesData.theft,
        legalaid: coveragesData.legalaid,
        hdiautoguard: false,
        accessories_and_safety: false,
        ter_ext: false,
      };

      if (typeof data?.selectedVehicle?.towingUnits != "undefined") {
        stringRates.withtrailer =
          data?.selectedVehicle?.towingUnits == "yes" ? true : false;
      }
      const resultSubmit = await dispatch(getRatesRedesign(stringRates));
      if (resultSubmit.payload.result) {
        setResultRates(resultSubmit.payload.data);
        if (!gettingQuote) {
          setGettingQuote(true);
        }
      } else {
        let mensaje = "\n";
        for (const key in resultSubmit.payload.message) {
          mensaje += "\u2B24" + " " + resultSubmit.payload.message[key] + "\n";
        }
      }
    }
  };

  const checkSelectedQuote = (days) => {
    return vehicleData.days === parseInt(days) ? "yellow" : "gray";
  };

  const setDays = (days) => {
    if (
      (vehicleData.days < 90 && parseInt(days) >= 90) ||
      (vehicleData.days < 365 && parseInt(days) >= 365)
    ) {
      //setOpen(true);
    }
    let vehicle = { ...vehicleData };
    vehicle.days = parseInt(days);
    setVehicleData(vehicle);
    let coveragesData = { ...coverages };
    coveragesData.days = parseInt(days);
    coveragesData = setExpirationDate(coveragesData);
    setCoverages(coveragesData);
    validateComplete(vehicle);
    getQuoteRates(coveragesData, vehicle);
    changeStep(vehicle, coveragesData);
  };
  const getDate = (type) => {
    const [year, month, day] = vehicleData.startDate.split("-").map(Number);
    const date = new Date(year, month - 1, day);
    date.setDate(date.getDate() + parseInt(vehicleData.days));

    const options = {
      month: "long",
      day: "numeric",
      year: "numeric",
    };

    let formattedDate = date.toLocaleDateString("en-US", options);

    const dayNumber = date.getDate();
    const suffix =
      dayNumber % 10 === 1 && dayNumber !== 11
        ? "st"
        : dayNumber % 10 === 2 && dayNumber !== 12
        ? "nd"
        : dayNumber % 10 === 3 && dayNumber !== 13
        ? "rd"
        : "th";

    formattedDate = formattedDate.replace(
      dayNumber.toString(),
      `${dayNumber}${suffix}`
    );

    return formattedDate;
  };

  const getDays = () => {
    return resultRates?.days1 != "undefined"
      ? daysOptions.find((e) => e.value == resultRates.days1).label
      : "0 days";
  };
  const timezones = {
    8: "California - PST",
    12: "Arizona - AT",
    17: "New Mexico/West Texas - MST",
    33: "Texas - CST",
  };
  const timezonesDateList = {
    8: "America/Los_Angeles",
    12: "America/Phoenix",
    17: "America/Mexico_City",
    33: "America/Chicago",
  };

  const today = new Date().toISOString().split("T")[0];
  const futureDate = new Date();
  futureDate.setDate(futureDate.getDate() + 60);
  const sixtyDaysLater = futureDate.toISOString().split("T")[0];
  const validateDateAndTime = (startDate, startTime, meridian, timezone) => {
    const timezoneId =
      typeof timezone !== "undefined" ? timezone : coverages.timezone;
    if (!startDate || !startTime) return false;
    let [hour, minute] = startTime.split(":");
    hour = meridian === "PM" && hour != "12" ? parseInt(hour) + 12 : hour;
    const formattedTime = `${String(hour).padStart(2, "0")}:${String(
      minute
    ).padStart(2, "0")}`;
    const selectedDateTime = new Date(`${startDate}T${formattedTime}`);
    const actualDate = new Date(currentStartDate);
    const optionsCurrentDate = {
      timeZone: timezonesDateList[timezoneId],
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    };
    const currentDateTimeZone = actualDate.toLocaleString(
      "en-EN",
      optionsCurrentDate
    );
    const currentDateTime = new Date(currentDateTimeZone);
    if (selectedDateTime >= currentDateTime && selectedDateTime < futureDate) {
      setValidDate(1);
    } else if (selectedDateTime < currentDateTime) {
      setValidDate(0);
    } else {
      setValidDate(2);
    }
  };

  return (
    <div>
      <GridItem xs={12} sm={12} md={12}>
        <div className={`${classesPrincipal.title} ${classesPrincipal.black}`}>
          {t("step4.title")}
        </div>

        <GridContainer style={{ marginTop: "20px" }}>
          <GridItem xs={12} sm={12} md={12}>
            <GridContainer>
              <GridItem xs={12} sm={12} md={8}>
                {validDate === 0 &&
                coverages.timeset &&
                coverages.startDate &&
                coverages.meridian ? (
                  <GridContainer>
                    <GridItem
                      style={{ marginTop: "30px", marginBottom: "20px" }}
                      xs={12}
                      sm={12}
                      md={12}
                    >
                      <CustomAlerts
                        title={""}
                        text={t("step4.dateAlert")}
                        variant="dangerOutlined"
                        icon="warning_amber"
                        severity="error"
                      />
                    </GridItem>
                  </GridContainer>
                ) : null}
                {validDate === 2 &&
                coverages.timeset &&
                coverages.startDate &&
                coverages.meridian ? (
                  <GridContainer>
                    <GridItem
                      style={{ marginTop: "30px", marginBottom: "20px" }}
                      xs={12}
                      sm={12}
                      md={12}
                    >
                      <CustomAlerts
                        title={""}
                        text={t("step4.dateAlert2")}
                        variant="dangerOutlined"
                        icon="warning_amber"
                        severity="error"
                      />
                    </GridItem>
                  </GridContainer>
                ) : null}
                <GridContainer>
                  <GridItem xs={12} sm={12} md={4}>
                    <CustomInput
                      labelText={t("step4.policyStartDate")}
                      error={!loginCredentials.login && sended ? true : null}
                      formControlProps={{
                        fullWidth: true,
                        className: classes.customFormControlClasses,
                      }}
                      min={today}
                      inputProps={{
                        required: true,
                        type: "date",
                        name: "startDate",
                        id: "startDateStep4",
                        value: coverages.startDate,
                        onChange: handleFormChange,
                        max: sixtyDaysLater,
                        disabled:
                          fieldEndorsement == "start_date" ? false : true,
                        //min: today,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={6} sm={6} md={4}>
                    <CustomSelect
                      labelText={t("step4.startTime")}
                      menuItems={[
                        { value: "12:00", label: "12:00" },
                        { value: "12:30", label: "12:30" },
                        { value: "1:00", label: "1:00" },
                        { value: "1:30", label: "1:30" },
                        { value: "2:00", label: "2:00" },
                        { value: "2:30", label: "2:30" },
                        { value: "3:00", label: "3:00" },
                        { value: "3:30", label: "3:30" },
                        { value: "4:00", label: "4:00" },
                        { value: "4:30", label: "4:30" },
                        { value: "5:00", label: "5:00" },
                        { value: "5:30", label: "5:30" },
                        { value: "6:00", label: "6:00" },
                        { value: "6:30", label: "6:30" },
                        { value: "7:00", label: "7:00" },
                        { value: "7:30", label: "7:30" },
                        { value: "8:00", label: "8:00" },
                        { value: "8:30", label: "8:30" },
                        { value: "9:00", label: "9:00" },
                        { value: "9:30", label: "9:30" },
                        { value: "10:00", label: "10:00" },
                        { value: "10:30", label: "10:30" },
                        { value: "11:00", label: "11:00" },
                        { value: "11:30", label: "11:30" },
                      ]}
                      error={!loginCredentials.login && sended ? true : null}
                      formControlProps={{
                        fullWidth: true,
                        className: classes.customFormControlClasses,
                      }}
                      name="startTime"
                      inputProps={{
                        required: true,
                        name: "startTime",
                        id: "startTimeStep4",
                        value: coverages.timeset,
                        onChange: handleFormChange,
                        disabled:
                          fieldEndorsement == "start_time" ? false : true,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={6} sm={6} md={2}>
                    <CustomToogle
                      helperText={null}
                      items={[
                        { value: "AM", label: "AM" },
                        { value: "PM", label: "PM" },
                      ]}
                      error={!loginCredentials.login && sended ? true : null}
                      formControlProps={{
                        fullWidth: true,
                        className: classes.customFormControlClasses,
                      }}
                      style={{ marginTop: "-20px" }}
                      name="meridian"
                      onChange={(e) => handleFormChange(e)}
                      defaultValue={coverages.meridian}
                      inline={true}
                      inputProps={{
                        required: true,
                        name: "meridian",
                        id: "meridianStep4",
                        value: coverages.meridian,
                        onChange: handleFormChange,
                        disabled:
                          fieldEndorsement == "start_time" ? false : true,
                      }}
                    />
                  </GridItem>
                </GridContainer>
                <GridItem
                  style={{
                    marginLeft: "-15px",
                    marginTop: "20px",
                    marginBottom: "20px",
                  }}
                  xs={12}
                  sm={12}
                  md={8}
                >
                  {vehicleData.days &&
                  vehicleData.startDate &&
                  vehicleData.startTime &&
                  coverages.meridian ? (
                    <CustomAlerts
                      title={t("step4.expireTitle")}
                      text={
                        <>
                          <span
                            className={classesPrincipal.red}
                            style={{
                              fontWeight: "bold",
                            }}
                          >
                            {getDate()} at {vehicleData.startTime}{" "}
                            {coverages.meridian} {timezones[coverages.timezone]}
                            .
                          </span>
                          <br />
                          {t("step4.expireText")}
                        </>
                      }
                      variant="successOutlined"
                      icon="warning_amber"
                      severity="success"
                    />
                  ) : null}
                </GridItem>
              </GridItem>
            </GridContainer>
            <GridContainer>
              <GridItem xs={8} sm={8} md={3}>
                <CustomSelect
                  labelText={t("step1.quote.borderCrossing")}
                  placeholder={t("step1.quote.borderCrossing")}
                  menuItems={
                    data?.catalogs
                      ? data.catalogs.borderCrossing.map((item) => ({
                          value: item.id,
                          label: item.name,
                        }))
                      : []
                  }
                  error={!loginCredentials.login && sended ? true : null}
                  formControlProps={{
                    fullWidth: true,
                    className: classes.customFormControlClasses,
                  }}
                  name="borderCrossing"
                  value={vehicleData.borderCrossing}
                  onChange={(e) => handleFormChange(e)}
                  inputProps={{
                    name: "borderCrossing",
                    id: "borderCrossingStep4",
                    value: vehicleData.borderCrossing
                      ? vehicleData.borderCrossing
                      : "placeholder",
                    onChange: handleFormChange,
                    disabled: fieldEndorsement == "time_zone" ? false : true
                  }}
                />
              </GridItem>
            </GridContainer>
            <GridContainer
              container
              justifyContent="space-between"
              alignItems="center"
              style={{ minHeight: "100px", marginTop: "20px" }}
            >
              <GridItem xs={4} sm={4} md={3}>
                <Button
                  id="backButton"
                  onClick={handlePreviewAction}
                  variant="white"
                  style={{ width: "100%" }}
                >
                  {t("common.previous")}
                </Button>
              </GridItem>
              <GridItem xs={4} sm={4} md={2} />
              <GridItem xs={4} sm={4} md={3}>
                <Button
                  id={isLogged ? "buyStep4" : "buyStep4Guest"}
                  type="submit"
                  onClick={handleSubmitStep}
                  disabled={!isCompleted || !(validDate === 1)}
                  variant="green"
                  style={{ width: "100%" }}
                >
                  {t("saveQuote")}
                </Button>
              </GridItem>
            </GridContainer>
          </GridItem>
        </GridContainer>
      </GridItem>
      <React.Fragment>
        <BootstrapDialog
          onClose={() => setOpen(false)}
          aria-labelledby="customized-dialog-title"
          open={open}
          fullWidth={true}
          maxWidth={"lg"}
        >
          <DialogTitle
            className={`${classesPrincipal.titleAccordion} ${classesPrincipal.black} ${classesPrincipal.title} ${classesPrincipal.yellowBackground}`}
            sx={{ m: 0, p: 2 }}
            id="customized-dialog-title"
          >
            {t("common.editQuote")}
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={() => setOpen(false)}
            sx={(theme) => ({
              position: "absolute",
              right: 8,
              top: 8,
              color: theme.palette.grey[500],
            })}
          ></IconButton>
          <DialogContent dividers>
            <GridItem xs={12} sm={12} md={12}>
              <GridContainer>
                <GridItem xs={5} sm={5} md={3}>
                  <CustomSelect
                    labelText={t("step1.quote.daysOfCoverage")}
                    menuItems={daysOptions}
                    error={!loginCredentials.login && sended ? true : null}
                    formControlProps={{
                      fullWidth: true,
                      className: classes.customFormControlClasses,
                    }}
                    placeholder={t("step1.quote.days")}
                    name="days"
                    information={"Tooltip Text"}
                    value={vehicleData.days}
                    onChange={(e) => handleFormChange(e)}
                    inputProps={{
                      name: "days",
                      id: "daysStep4",
                      value: vehicleData.days
                        ? vehicleData.days
                        : "placeholder",
                      onChange: handleFormChange,
                    }}
                  />
                </GridItem>
                <GridItem xs={8} sm={8} md={3}>
                  <CustomSelect
                    labelText={t("step1.quote.borderCrossing")}
                    placeholder={t("step1.quote.borderCrossing")}
                    menuItems={
                      data?.catalogs
                        ? data.catalogs.borderCrossing.map((item) => ({
                            value: item.id,
                            label: item.name,
                          }))
                        : []
                    }
                    error={!loginCredentials.login && sended ? true : null}
                    formControlProps={{
                      fullWidth: true,
                      className: classes.customFormControlClasses,
                    }}
                    name="borderCrossing"
                    value={vehicleData.borderCrossing}
                    onChange={(e) => handleFormChange(e)}
                    inputProps={{
                      name: "borderCrossing",
                      id: "borderCrossingStep4",
                      value: vehicleData.borderCrossing
                        ? vehicleData.borderCrossing
                        : "placeholder",
                      onChange: handleFormChange,
                    }}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={8} sm={8} md={6}>
                  <CustomSelect
                    labelText={t("step1.quote.vehicleType")}
                    menuItems={
                      data?.catalogs
                        ? data.catalogs.vehicle_types.map((item) => ({
                            value: item.id,
                            label: item.name,
                            icon: item.icon,
                          }))
                        : []
                    }
                    error={!loginCredentials.login && sended ? true : null}
                    formControlProps={{
                      fullWidth: true,
                      className: classes.customFormControlClasses,
                    }}
                    name="vehtype"
                    onChange={(e) => handleFormChange(e)}
                    inputProps={{
                      name: "vehtype",
                      id: "vehtypeStep4",
                      value: vehicleData.vehtype,
                      onChange: handleFormChange,
                    }}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={6} sm={6} md={4}>
                  <CustomSelect
                    labelText={t("step1.quote.vehicleValue")}
                    placeholder={t("step1.quote.actualCash")}
                    menuItems={
                      valores
                        ? valores.map((item) => ({
                            value: item.value,
                            label: item.traduccion,
                          }))
                        : []
                    }
                    information={
                      <div
                        dangerouslySetInnerHTML={{
                          __html: t("step1.quote.valueVehicleInfo"),
                        }}
                      />
                    }
                    formControlProps={{
                      fullWidth: true,
                      className: classes.customFormControlClasses,
                    }}
                    name="login"
                    onChange={(e) => handleFormChange(e)}
                    inputProps={{
                      name: "total_value_vehicle",
                      id: "total_value_vehicleStep4",
                      value:
                        vehicleData.total_value_vehicle != null
                          ? vehicleData.total_value_vehicle
                          : "placeholder",
                      onChange: handleFormChange,
                    }}
                  />
                </GridItem>
              </GridContainer>
              {vehicleData.vehtype !== "11" && (
                <GridContainer>
                  <GridItem xs={6} sm={6} md={4}>
                    <CustomSelect
                      labelText={t("step1.quote.towedUnitsValue")}
                      information={
                        <div
                          dangerouslySetInnerHTML={{
                            __html: t("step1.quote.towedUnitsInfo"),
                          }}
                        />
                      }
                      menuItems={
                        valores
                          ? [
                              { value: -1, label: t("vehicles.noTowedUnits") },
                              ...valores.map((item) => ({
                                value: item.value,
                                label: item.traduccion,
                              })),
                            ]
                          : [{ value: -1, label: t("vehicles.noTowedUnits") }]
                      }
                      error={!loginCredentials.login && sended ? true : null}
                      formControlProps={{
                        fullWidth: true,
                        className: classes.customFormControlClasses,
                      }}
                      name="login"
                      onChange={(e) => handleFormChange(e)}
                      inputProps={{
                        name: "total_value_trailer",
                        id: "total_value_trailerStep4",
                        value: vehicleData.total_value_trailer
                          ? vehicleData.total_value_trailer
                          : -1,

                        onChange: handleFormChange,
                      }}
                    />
                  </GridItem>
                </GridContainer>
              )}

              <GridContainer>
                {vehicleData && vehicleData.days && vehicleData.days >= 90 ? (
                  <GridItem xs={12} sm={12} md={8}>
                    <CustomToogle
                      labelText={t("step1.quote.vehicleCoverageSonoraBC")}
                      helperText={null}
                      items={[
                        { value: "yes", label: "Yes" },
                        { value: "no", label: "No" },
                      ]}
                      error={!loginCredentials.login && sended ? true : null}
                      formControlProps={{
                        fullWidth: true,
                        className: classes.customFormControlClasses,
                      }}
                      name="login"
                      onChange={(e) => handleFormChange(e)}
                      inputProps={{
                        required: true,
                        name: "mexcoverage",
                        id: "mexcoverageStep4",
                        value: vehicleData.mexcoverage,
                        onChange: handleFormChange,
                      }}
                    />
                  </GridItem>
                ) : null}
              </GridContainer>
              <GridContainer>
                {vehicleData && vehicleData.days && vehicleData.days > 360 ? (
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomToogle
                      labelText={t("step1.quote.sentriPass")}
                      helperText={null}
                      items={[
                        { value: "yes", label: "Yes" },
                        { value: "no", label: "No" },
                      ]}
                      error={!loginCredentials.login && sended ? true : null}
                      formControlProps={{
                        fullWidth: true,
                        className: classes.customFormControlClasses,
                      }}
                      name="login"
                      onChange={(e) => handleFormChange(e)}
                      defaultValue="no"
                      inputProps={{
                        required: true,
                        name: "sentripass",
                        id: "sentripassStep4",
                        value: vehicleData.sentripass,
                        onChange: handleFormChange,
                      }}
                    />
                  </GridItem>
                ) : null}
              </GridContainer>
              <GridContainer>
                <GridItem xs={6} sm={6} md={4}>
                  <CustomSelect
                    labelText={t("step1.quote.selectAgent")}
                    information={t("step1.quote.selectAgentInfo")}
                    helperText={
                      !loginCredentials.login && sended
                        ? "Vehicle type field is required."
                        : null
                    }
                    menuItems={
                      data?.catalogs
                        ? data.catalogs.agencies.map((item) => ({
                            value: item.id,
                            label: `${item.city} ${item.agency_name}`,
                          }))
                        : []
                    }
                    error={!loginCredentials.login && sended ? true : null}
                    formControlProps={{
                      fullWidth: true,
                      className: classes.customFormControlClasses,
                    }}
                    name="login"
                    onChange={(e) => handleFormChange(e)}
                    inputProps={{
                      name: "agent",
                      id: "agentStep4",
                      value: vehicleData.agent,
                      onChange: handleFormChange,
                    }}
                  />
                </GridItem>
              </GridContainer>
            </GridItem>
            <GridItem xs={12} sm={12} md={12}>
              <GridContainer
                style={{ padding: "40px 0px 40px 0px" }}
                justify={isSmall ? "center" : "left"}
              >
                <GridItem xs={5} sm={5} md={2}>
                  <div style={{ marginTop: "10px" }} className={classes.center}>
                    <Button
                      disabled={!isCompleted || !(validDate === 1)}
                      id={
                        isLogged ? "recalculateStep4" : "recalculateStep4Guest"
                      }
                      type="submit"
                      onClick={() => {
                        setOpen(false);
                        handleSubmit();
                      }}
                      variant="green"
                      block
                    >
                      {t("common.recalculate")}
                    </Button>
                  </div>
                </GridItem>
              </GridContainer>
            </GridItem>
          </DialogContent>
        </BootstrapDialog>
      </React.Fragment>
    </div>
  );
});

Step1.displayName = "Step1";

export default Step1;
